import script from "./InitializingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InitializingPage.vue?vue&type=script&setup=true&lang=js"

import "./InitializingPage.vue?vue&type=style&index=0&id=359a50d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-359a50d8"]])

export default __exports__